import { PaletteOptions, PaletteMode } from '@mui/material';
import { GetThemeOptions } from '../theme';
import { unityDarkTokens, unityLightTokens } from '../unityTokens';
import { grey } from './colors';

export const text = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['text'] => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          bold: unityLightTokens['--text-bold-color'],
          default: unityLightTokens['--text-default-color'],
          disabled: unityLightTokens['--text-disabled-color'],
          primary: unityLightTokens['--text-default-color'],
          secondary: unityLightTokens['--text-default-color'],
          // once we flip the feature flag, we can clean references to these colors up
          inversePrimary: unityLightTokens['--text-default-color'],
          inverseSecondary: unityLightTokens['--text-inverse-color'],
          navigationHeader: unityLightTokens['--text-inverse-color'],
          accent: unityLightTokens['--text-default-color'],
        }
      : {
          bold: unityDarkTokens['--text-bold-color'],
          default: unityDarkTokens['--text-default-color'],
          disabled: unityDarkTokens['--text-disabled-color'],
          primary: unityDarkTokens['--text-default-color'],
          secondary: unityDarkTokens['--text-default-color'],
          // once we flip the feature flag, we can clean references to these colors up
          inversePrimary: unityDarkTokens['--text-inverse-color'],
          inverseSecondary: unityDarkTokens['--text-inverse-color'],
          navigationHeader: unityDarkTokens['--text-default-color'],
          accent: unityDarkTokens['--text-default-color'],
        };
  }

  const accent = grey[300];
  return mode === 'light'
    ? {
        // not used unless panwRebrandStubYear is true, but we need to keep the keys for backwards compatibility
        bold: grey[950],
        default: grey[600],
        // ^^^
        primary: grey[950],
        secondary: grey[600],
        disabled: grey[300],
        inversePrimary: grey[50],
        inverseSecondary: grey[200],
        navigationHeader: grey[200],
        accent,
      }
    : {
        // not used unless panwRebrandStubYear is true, but we need to keep the keys for backwards compatibility
        bold: grey[50],
        default: grey[200],
        // ^^^
        primary: grey[50],
        secondary: grey[200],
        disabled: grey[500],
        inversePrimary: grey[950],
        inverseSecondary: grey[600],
        navigationHeader: grey[200],
        accent,
      };
};
